// Routes
export const HOME_ROUTE = "/:lng/";
export const LOGIN_ROUTE = "/:lng/login";
export const REGISTER_ROUTE = "/:lng/register";
export const LOGIN_EDIT = "/:lng/login-edit";

export const STUDENT_PROFILE_ROUTE = "/:lng/student-edit-first";
export const STUDENT_PROFILEEDIT_ROUTE = "/:lng/student-edit";
export const STUDENT_PROFILEVIEW_ROUTE = "/:lng/student";
export const STUDENT_ROOMS_ROUTE = "/:lng/rooms";
export const STUDENT_ROOMINFO_ROUTE = "/:lng/room-info";
export const STUDENT_MATCHES_ROUTE = "/:lng/matches";
export const STUDENT_CHATS_ROUTE = "/:lng/chats";

export const HOST_PROFILE_ROUTE = "/:lng/host-edit-first";
export const HOST_PROFILEEDIT_ROUTE = "/:lng/host-edit";
export const HOST_PROFILEVIEW_ROUTE = "/:lng/host";
export const HOST_ROOMS_ROUTE = "/:lng/rooms";
export const HOST_ROOMADD_ROUTE = "/:lng/room-add";
export const HOST_ROOMEDIT_ROUTE = "/:lng/room-edit";
export const HOST_MATCHES_ROUTE = "/:lng/matches";
export const HOST_CHATS_ROUTE = "/:lng/chats";
export const HOST_TENANTS_ROUTE = "/:lng/tenants";

export const FINDROOM_ROUTE = "/:lng/students";
export const BECOMEHOST_ROUTE = "/:lng/hospita";
export const TEAM_ROUTE = "/:lng/team";
export const PRESS_ROUTE = "/:lng/press";
export const PARTNERS_ROUTE = "/:lng/partners";
export const MISSION_ROUTE = "/:lng/mission";
export const BLOG_ROUTE = "/:lng/blog";
export const VACANCIES_ROUTE = "/:lng/vacancies";
export const FAQ_ROUTE = "/:lng/faq";
export const CONTACT_ROUTE = "/:lng/contact";
export const POPUPMENU_ROUTE = "/:lng/menu";
export const PRIVACY_ROUTE = "/:lng/privacy";
export const COOKIES_ROUTE = "/:lng/cookies";
export const CONTACTDETAILS_ROUTE = "/:lng/contactdetails";

// SERVER API  PATH
export const API_USERS = "users/api/";
export const API_HOUSES = "houses/api/";
export const API_STUDENT = "houses/api/";
export const API_MATCHES = "matches/api/";
export const API_CHATS = "chats/api/";

// Empty string for validator
export const EMPTY = "empty";

export enum WEEK {
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
}

export enum MONTHS {
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
}

export const ERROR404 = "Error 404";
export const ERRORANY = "Error any";

// Using Languages
export const LANGUAGES = ["GB", "NL"];


// Student requests
export const HousesOnPage = 4;
export const FilterRooms = ["highLow", "lowHigh", "newest", "liked"];

// Host House

export const TYPE_ROOM = ["room", "studio", "entire_house"];

export const TYPE_GENDER = ["male", "female", "any"];

export const HOUSE_STATUS = ["DRAFT", "PUBLISHED", "RENTED", "ARCHIVED"];

//  Match service
export enum matchStatus {
  LIKED = 1,
  CHATTED,
  INVITED,
  ACEPTED,
  PENDING,
  ACTIVE,
  ARCHIVED
}

export const SHARED_USE = [
  "toilet",
  "bathroom",
  "kitchen",
  "livingroom",
  "washing machine",
  "terrace",
  "balcony",
  "garden",
];

export const PRIVATE_USE = [
  "toilet",
  "bathroom",
  "kitchen",
  "furnished room",
  "sink",
  "internet",
  "double bed",
  "balcony",
  "tv",
];

